export function Row({ label, value, muted, tone }: { label: string; value: string; muted?: boolean; tone?: "green" }) {
  return (
    <div className="flex items-center justify-between">
      <dt className={muted ? "text-on-surface-variant/70 dark:text-secondary-fixed-dim" : "text-on-surface-variant dark:text-secondary-fixed-dim"}>{label}</dt>
      <dd className={`font-medium ${tone === "green" ? "text-secondary dark:text-[#b8ae9e]" : "text-on-background dark:text-inverse-on-surface"} ${muted ? "!font-normal text-on-surface-variant/70 dark:!text-secondary-fixed-dim" : ""}`}>{value}</dd>
    </div>
  );
}
